// Schulden-Kennzahl der Betreuungsakte (02.11.2026): unbekannt ist nie "0 €" und nie gruen.
// statistik.schulden_status vom Backend: erfasst | keine_eintraege | nicht_erfasst (aeltere Backends: fehlt -> wie bisher nur mit Betrag > 0).
export function schuldenAnzeige(statistik) {
  const st = statistik?.schulden_status;
  const summe = Number(statistik?.schulden_gesamt) || 0;
  if (st === 'erfasst' || (!st && summe > 0)) {
    return { betrag: `${summe.toLocaleString('de-DE')} €`, text: null, hinweis: null };
  }
  if (st === 'keine_eintraege') {
    return { betrag: null, text: 'keine Gläubiger erfasst', hinweis: 'Kein Nachweis, dass keine Schulden bestehen' };
  }
  return { betrag: null, text: 'nicht erfasst', hinweis: 'Finanzstatus noch nicht erfasst' };
}
